import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IProductCard } from "@/shared/types/feed"
import { ISingleProductState } from "./types"

const initialState: ISingleProductState = {
	product: null,
	loading: false,
	error: null,
}

const singleProductSlice = createSlice({
	name: "singleProduct",
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload
		},
		setProduct: (state, action: PayloadAction<IProductCard>) => {
			state.product = action.payload
			state.error = null
		},
		setError: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.product = null
		},
		clearProduct: state => {
			state.product = null
			state.error = null
		},
		clearError: state => {
			state.error = null
		},
	},
})

export const { setLoading, setProduct, setError, clearProduct } = singleProductSlice.actions
export default singleProductSlice.reducer
